var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff2147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.9 422.3c10.6 0 21.7 0 33.8.2l8.6 8.7c3.5 3.5 7.1 7.2 10.8 10.8H70v-4.2c0-5.5 0-10.8.2-15.2 10.4-.2 21.2-.3 32.7-.3m300 .1c11.7 0 23.7 0 35.3.1h3.6c.1 7.1.2 13.9-.1 19.4-21.6 0-45.2.1-73.6.1h-12.3c4.1-4 8-7.9 11.9-11.7 2.7-2.7 5.3-5.3 7.9-7.8 8.4-.1 17.4-.1 27.3-.1m-300-70.1c-13.6 0-27.2.1-40.8.3-29.3.5-55 21.8-60.1 50.9-2.4 13.1-2 26.9-2 40.3 0 40.9 27.4 68.1 68.2 68.2h299.9c26.3 0 52.6 0 78.9-.1 31.7-.1 58-21.3 63.1-52.6 2.3-13.9 1.8-28.3 1.6-42.5-.5-36.7-28.7-64.2-65.6-64.4-14.4-.1-28.9-.1-43.3-.1-15.8 0-31.6.1-47.4.4-5 .1-10.9 2.8-14.6 6.2-13.7 12.4-26.4 25.9-39.9 38.5-13.7 12.9-29.5 19.3-45.3 19.3-16.2 0-32.3-6.8-46.2-20.4-12.9-12.7-25.5-25.8-38.6-38.3-3-2.8-7.8-5.4-11.7-5.4-18.6-.1-37.4-.3-56.2-.3z",
    fill: "#27447c",
    opacity: 1,
    "data-original": "#ff2147",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 275V33.9c.1-25.2 21.8-40.3 44.4-31.2 12.4 5 19 15.7 19 31.6v240.5c4.4-4 7.2-6.2 9.7-8.8 20.8-21 41.4-42 62.3-62.9 9.2-9.2 20.1-12.9 33.1-9.4 12.2 3.3 19.5 11.4 22.2 23.5 2.6 11.6-.6 22.1-8.9 30.4-42.1 42.4-84.4 84.6-126.8 126.7-13.8 13.6-33 13.4-46.9-.3-42.2-41.8-84.2-83.8-126-126-13.6-13.8-13.5-34.7-.7-47s32.9-11.6 46.9 2.4c20.6 20.6 41 41.5 61.5 62.2 2.7 2.6 5.5 5 10.2 9.4z",
    fill: "#27447c",
    opacity: 1,
    "data-original": "#ff2147",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f5033c3a5234b7d0dd492cddf5bbd41a.svg";
export { ForwardRef as ReactComponent };